import { Coins, ListChecks, Sparkles } from "lucide-react";

const STEPS = [
  {
    icon: Coins,
    title: "You give",
    body: "Start a monthly gift from $15 or more, give once, sponsor a project, or run your own fundraiser. We also accept company matches.",
  },
  {
    icon: ListChecks,
    title: "We pick what helps most",
    body: "Requests come in from villages and partners across Sri Lanka. Our volunteer team checks each one and shortlists what to fund next.",
  },
  {
    icon: Sparkles,
    title: "You see the result",
    body: "Local partners do the work on the ground. We follow every project to the end and send back the photos and the story.",
  },
];

export function HowItWorks() {
  return (
    <section className="bg-muted/30 py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">
            How it works
          </span>
          <h2 className="mt-3 font-display text-4xl font-semibold leading-tight md:text-5xl text-balance">
            From your gift to a real life changed
          </h2>
        </div>
        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="rounded-2xl bg-card p-8 shadow-card">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <Icon className="h-6 w-6" />
                </div>
                <div className="mt-5 font-display text-sm font-semibold uppercase tracking-widest text-primary">
                  Step {i + 1}
                </div>
                <h3 className="mt-1 font-display text-2xl font-semibold">
                  {s.title}
                </h3>
                <p className="mt-3 text-muted-foreground">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
